import { Form, FormInstance } from "antd";
import React from "react";
import { edAttrField } from "src/pages/ManagementPage/Obj2Tab/EdAttribute";
import { Separator } from "src/common/attrView/viewFormItems/Separator";
import { SelectAttributesRolesList } from "../../ViewInfo/SelectAttributesRolesList";
import { edCompField } from "../ParamsEditorInfo2";
import { MultipleChoiceIteratorDepend } from "./common";

type Props = {
  form: FormInstance;
};
export const PersonSelectEdProps: React.FC<Props> = ({ form }) => {
  const roleIds = Form.useWatch(edAttrField.roleIds) || [];
  return (
    <>
      <MultipleChoiceIteratorDepend form={form} />
      <SelectAttributesRolesList
        rolesIds={roleIds}
        name={edCompField("rolesViewAtts")}
      />
      <Separator name={edCompField("separator")} excludedValues={["newLine"]} />
    </>
  );
};
